import React, { Component } from "react";
import { Box, ChakraProvider } from "@chakra-ui/react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import queryString from 'query-string';
import { formatISO, add } from "date-fns";

import Sidebar from "./Components/Sidebar.jsx";
import Navbar from "./Components/Navbar.jsx";
import ModalAbout from "./Components/ModalAbout.jsx";
import MsgBox from "./Components/MsgBox.jsx";

import "../../assets/css/admin.css";



import ConfigService from "../../services/ConfigService.js";
import AuthService from "../../services/AuthService.js";
import AuthResourceService from "../../services/AuthResourceService.js";
import CoreService from "../../services/CoreService.js";
import LocalStorageService from "../../services/LocalStorageService.js";
import LocalQueuedDbService from "../../services/LocalQueuedDbService.js";
import LocalSuspendedDbService from "../../services/LocalSuspendedDbService.js";
import IdentityService from "../../services/IdentityService.js";
import DeviceInfo from "../../components/lib/Device/DeviceInfo.jsx";
import UserSessionKey from "../../models/UserSessionKey.js";
import JwtToken from "../../components/lib/tokens/JwtToken.js";

import AuthPage from "../../pages/Auth/AuthPage.jsx";
import ErrorPage from "../../pages/Error/ErrorPage.jsx";
import DataManagementPage from "../../pages/DataManagement/DataManagementPage.jsx";
import UserManagementPage from "../../pages/UserManagement/UserManagementPage.jsx";
import SchemaManagementPage from "../../pages/SchemaManagement/SchemaManagementPage.jsx";
import OrgConfigManagementPage from "../../pages/OrgConfigManagement/OrgConfigManagementPage.jsx";
import ObsHomePage from "../../pages/ObsHome/ObsHomePage.jsx";
import DashboardPage from "../../pages/Dashboard/DashboardPage.jsx";
import SubscriberManagementPage from "../../pages/SubscriberManagement/SubscriberManagementPage.jsx";
import ObservationPage from "../../pages/Observation/ObservationPage.jsx";
import EntityManagementPage from "../../pages/EntityManagement/EntityManagementPage.jsx";
import ReportNavigatorPage from "../../pages/ReportViewer/ReportNavigatorPage.jsx";
import SharedReportNavigatorPage from "../../pages/ReportViewer/SharedReportNavigatorPage.jsx";
import ChangeHistoryPage from "../../pages/ChangeHistory/ChangeHistoryPage.jsx";
import DataApiInstructionsPage from "../../pages/DataAnalytics/DataApiInstructionsPage.jsx";

import FileManager from "../../managers/FileManager.js";


import RoleManager from "../../models/RoleManager.js";
import { AppSecurityKey } from "../../models/AppSecurityKey.js";
import { ObservationSessionMode } from "../../models/ObservationSessionMode.js";
import { SystemErrorLevelType } from "../../models/SystemErrorLevelType.js";
import LotWatcher from "./Components/LotWatcher.jsx";
import ObsSearchParams from "../../models/ObsSearchParams.js";






function isOnline() {
  return navigator.onLine;
}


export default class HomeLayout extends Component 
{
  constructor(props) {
    super(props);

    this.deviceInfo = new DeviceInfo().getDeviceInfo();
    this.localStorageService = new LocalStorageService();
    this.localQueuedDbService = new LocalQueuedDbService();
    this.localSuspendedDbService = new LocalSuspendedDbService();
    this.configService = new ConfigService();
    this.authService = new AuthService();
    this.authResourceService = new AuthResourceService();
    this.coreService = new CoreService();

    let lastUserSession = this.localStorageService.hasLastUserSession()
      ? this.localStorageService.getLastUserSession()
      : {
          isValid: false,
          gcid: "",
          uid: "",
          name: "",
          title: "",
          token: "",
          app: "",
          offlineTokenCanExpire: true,
          allowedScopes: [],
          isAirplaneMode: false,
          roles: [],
          locations: [],
          currentLocationId: "",
          schemas: [],
          currentSchemaId: "",
          inObservationSession: false,
          observationSessionMode: ObservationSessionMode.NONE, 
          isInObservationSession: false,
          initialValueBag: null,   // allows you to initialize the valuebag for certain modes (RESUME, copy from previous observation)
          selectedLotId: null,
          runLotWatcher: false,
          lotWatcherRunning: false,
          suspendedTags: [],
          autoRefresh: true,
          autoRefreshTriggerKey: "",
          healthInfo: null,
          healthInfoTriggerKey: ""
        };

    this.state = 
    {
      showFrames: false,
      systemErrorMsg: "",
      systemErrorLevel: SystemErrorLevelType.INFO,
      isLoggedIn: false,
      isInLogout: false,
      appInfo: {
        version: {
          build: ""
        },
      },
      onlineInfo: {
        isOnline: false, // user has network access
        isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
        isConnected: false,
      }, // are we accessing network resources (because we are online AND NOT in Airplane mode)
      onLineStatusChangeKey: IdentityService.makeUuid(),
      isGeolocationEnabled: false,
      userSession: lastUserSession,
      userSessionKey: "",
      isAboutOpen: false,
      navigatorInfo: null,
      msgBoxSwal: {show: false},
      sessionExpiration: null,
      currentLocationId: null,
      inQueueCount: 0,
      globalObsSearchParams: null,
      globalDashSearchParams: null,
      globalObsFilterParams: null,
      globalDashFilterParams: null

    };

    this.setFramesVisibility = this.setFramesVisibility.bind(this);
    this.goToLandingPage = this.goToLandingPage.bind(this);

    this.onSuccessfulLogin = this.onSuccessfulLogin.bind(this);
    this.onLogoutRequest = this.onLogoutRequest.bind(this);
    this.onToastRequest = this.onToastRequest.bind(this);

    this.onAboutOpen = this.onAboutOpen.bind(this);
    this.onAboutClose = this.onAboutClose.bind(this);
    this.onMsgBoxRequest = this.onMsgBoxRequest.bind(this);
    this.onMsgBoxCloseRequest = this.onMsgBoxCloseRequest.bind(this);
 
    this.onCurrentLocationIdUpdateRequest = this.onCurrentLocationIdUpdateRequest.bind(this);
    this.onCurrentSchemaIdUpdateRequest = this.onCurrentSchemaIdUpdateRequest.bind(this);

    this.onGeolocationStatusUpdateRequest = this.onGeolocationStatusUpdateRequest.bind(this);
    this.onToggleAirplaneModeRequest = this.onToggleAirplaneModeRequest.bind(this)
    this.notAvailableOfflineCheck = this.notAvailableOfflineCheck.bind(this);
    this.onPurgeOfflineObservationsRequest = this.onPurgeOfflineObservationsRequest.bind(this);
    this.purgeLocalQueue = this.purgeLocalQueue.bind(this);


    this.onLotSelectionChange = this.onLotSelectionChange.bind(this);
    this.onHomePageRequest = this.onHomePageRequest.bind(this);
    this.onDataManagementPageRequest = this.onDataManagementPageRequest.bind(this);
    this.onUserManagementPageRequest = this.onUserManagementPageRequest.bind(this);
    this.onSchemaManagementPageRequest = this.onSchemaManagementPageRequest.bind(this);
    this.onOrgConfigManagementPageRequest = this.onOrgConfigManagementPageRequest.bind(this);
    this.onSubscriberManagementPageRequest = this.onSubscriberManagementPageRequest.bind(this);
    this.onDashboardPageRequest = this.onDashboardPageRequest.bind(this);
    this.onErrorPageRequest = this.onErrorPageRequest.bind(this);
    this.onObservationPageRequest = this.onObservationPageRequest.bind(this);
    this.onChangeHistoryPageRequest = this.onChangeHistoryPageRequest.bind(this);
    this.onDataApiInstructionsPageRequest = this.onDataApiInstructionsPageRequest.bind(this);

    this.onExpiredToken = this.onExpiredToken.bind(this);
    this.updateSessionExpiration = this.updateSessionExpiration.bind(this);
    this.onUpdatedLotsEvent = this.onUpdatedLotsEvent.bind(this);
    this.onUpdateInQueueCount = this.onUpdateInQueueCount.bind(this);

    this.onUserGuideRequest = this.onUserGuideRequest.bind(this);
    this.onEntityManagementPageRequest = this.onEntityManagementPageRequest.bind(this);
    this.onViewReportRequest = this.onViewReportRequest.bind(this);
    this.onViewSharedReportRequest = this.onViewSharedReportRequest.bind(this);

    this.runLotWatcher = this.runLotWatcher.bind(this);
    this.stopLotWatcher = this.stopLotWatcher.bind(this);
    this.onLotWatcherRunningStatusChange = this.onLotWatcherRunningStatusChange.bind(this);

    this.onSuspendedObservationChange = this.onSuspendedObservationChange.bind(this);
    this.onToggleAutoRefresh = this.onToggleAutoRefresh.bind(this);
    this.onTriggerAutoRefresh = this.onTriggerAutoRefresh.bind(this);
    this.onHealthInfoUpdate = this.onHealthInfoUpdate.bind(this);

    this.logInSharedReportViewer = this.logInSharedReportViewer.bind(this);

    this.onGlobalSearchParamsChange = this.onGlobalSearchParamsChange.bind(this);
    this.onGlobalFilterParamsChange = this.onGlobalFilterParamsChange.bind(this);
   

  }


  onGlobalSearchParamsChange(globalSearchParams, parentComponent)
  {
    if (parentComponent === "observationhome")
    {
      this.setState({globalObsSearchParams: globalSearchParams});
    }
    else
    {
      this.setState({globalDashSearchParams: globalSearchParams});
    }
  }

  onGlobalFilterParamsChange(globalFilterParams, parentComponent)
  {
    if (parentComponent === "observationhome")
    {
        this.setState({globalObsFilterParams: globalFilterParams});
    }
    else
    {
        this.setState({globalHistoryFilterParams: globalFilterParams});
    }
  }

  async logInSharedReportViewer(qString)
  {
    //const url = new URL(window.location.href);
    const queryStringValues = queryString.parse(qString)//url.search);



    const claimToken = queryStringValues.ct; // password
    const gcid = queryStringValues.gcid;
    const observationId = queryStringValues.oid;
    const reportName = (queryStringValues.rn==="undefined") ? "observation": queryStringValues.rn;
    if ((!gcid) || (!claimToken) || (!observationId) || (!reportName))
    {
      this.onErrorPageRequest("Bad parameters.")
      return;
    }
    // TBD - check that they are using a valid browser and have the latest build
    // how do we bootstrap security enough to even check if this is a valid token?
    const uid = "shared.report.viewer." + gcid;
    let isAuthorizedResult = await this.authService.isAuthorizedUserLogin(gcid, uid, claimToken);
    if (isAuthorizedResult.hasError) {
      this.onErrorPageRequest("Authorization Error");
      return;
    }
    if (!isAuthorizedResult.dataResult) {
      this.onErrorPageRequest("Unauthorized.")
      return;
    }
    // note that the base user scope allows us to "bootstrap" the user up to full role scopes.
    var tokenResult = await this.authService.getUserToken(gcid, uid, claimToken, this.configService.getBaseUserScope());
    if (tokenResult.hasError) {
      this.onErrorPageRequest("Bad token. Unauthorized.");
      return;
    }
    var sessionToken = tokenResult.dataResult;
    var tokenPayload = JwtToken.getTokenPayload(sessionToken);

    var scopesResult = await this.authResourceService.getScopesByRoles(tokenPayload.roles, sessionToken);
    if (scopesResult.hasError) {
      this.onErrorPageRequest(" Scopes error. Unauthorized.")
      return;
    }
    var fullTokenResult = await this.authService.getUserToken(gcid, uid, claimToken, scopesResult.dataResult)
    if ((fullTokenResult.hasError) || (!fullTokenResult.dataResult)) {
      this.onErrorPageRequest("User Token Error. Unauthorized.");
      return;
    }

    let onlineInfo = isOnline()
    ? {
        isOnline: true, // user has network access
        isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
        isConnected: true
      }
    : {
        isOnline: false, // user has network access
        isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
        isConnected: false,
      };
  this.setState({ onlineInfo: onlineInfo });

  this.updateSessionExpiration(JwtToken.toExpiredDateTime(sessionToken));

    sessionToken = fullTokenResult.dataResult;
    var userSession = {
      isValid: true,
      gcid: gcid,
      uid: uid,
      token: sessionToken,
      roles: tokenPayload.roles,
      locations:tokenPayload.locations,
      currentLocationId: "",
      currentSchemaId:  "",
      schemas: tokenPayload.schemas,
      app: null 
    };

    this.setState({userSession: userSession, isLoggedIn: true});


    // confirm that the observation actually exists
    var searchParams = new ObsSearchParams();
    searchParams.id = observationId;
    searchParams.gcid = gcid;
    let observationListResult = await this.coreService.fetchObservation(observationId, gcid, sessionToken);
    if (observationListResult.hasError || observationListResult.dataResult.length < 1)
    {
      this.onErrorPageRequest("Observation error. Unauthorized.")
      return;
    }

    let observation = observationListResult.dataResult[0];

    let schemaResult = await this.coreService.fetchSchema(observation.data.schema.id, gcid, sessionToken);
    // save it locally
    this.localStorageService.saveSchema(observation.data.schema.id, schemaResult.dataResult);

    this.setFramesVisibility(false);
    console.log("About to route to Shared Report Request.");
    this.onViewSharedReportRequest(observationListResult.dataResult[0], reportName, userSession);
  }


  async componentDidMount() 
  {


    // am I coming in as a "grower" report request? If so, I will have a token AND
    // a valid observationId
    const url = new URL(window.location.href);
    var queryStringValues = queryString.parse(url.search);
    var claimToken = queryStringValues.ct;
    const shortUrlKey = queryStringValues.su;
    if ((shortUrlKey) && (shortUrlKey.length > 0))
    {
      // fetch the shortUrl values
      var shortUrlStringResponse = await this.coreService.fetchShortUrl(shortUrlKey);
      if (shortUrlStringResponse.hasError)
      {
        this.onErrorPageRequest("Unauthorized. Not found.")
        return;
      }
      await this.logInSharedReportViewer(shortUrlStringResponse.dataResult.queryString);
      return;
    }
    else if ((claimToken) && (claimToken.length > 0))
    {
        await this.logInSharedReportViewer(url.search);
        return;
    }
    else
    {


    // if I am connected, then I MUST log in.
    // if I am NOT connected, then I MUST have userSessionInfo stored.
    // AND if offlineTokenCanExpire is TRUE, then the token cannot have expired.
    let onlineInfo = isOnline()
      ? {
          isOnline: true, // user has network access
          isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
          isConnected: true
        }
      : {
          isOnline: false, // user has network access
          isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
          isConnected: false,
        };
    this.setState({ onlineInfo: onlineInfo });

  
    // do we even HAVE a last userSession?
    if (!this.localStorageService.hasLastUserSession()) 
    {
      
      console.log("No previous user session found.");
      this.setState({
        SystemErrorLevel: SystemErrorLevelType.INFO,
        systemErrorMsg: "Please log in.",
      });
      this.setFramesVisibility(false);
      this.props.history.replace("/home/error-page");
      return;
    } 

    var userSession = this.localStorageService.getLastUserSession();
    var userSessionKey =
        UserSessionKey.fromUserSession(userSession).toQueryString();
    if (!JwtToken.isValidToken(userSession.token)) 
    {
        this.setFramesVisibility(false);
        this.setState({
          systemErrorLevel: SystemErrorLevelType.WARNING,
          systemErrorMsg: "Last Saved user Session has an invalid Jwt Token!"
        });
        this.props.history.replace("/home/error-page");
        return;
    }
    //if (this.state.userSession.offlineTokenCanExpire) {
      console.log("Checking Expired token...");
    if (JwtToken.isTokenExpired(userSession.token) && (!this.state.isInLogout)) 
    {

      console.log("Expiring token");
        this.setState({
          systemErrorMsg:
            "Your session has expired. Please log in again.",
        });
        this.setFramesVisibility(false);
        this.props.history.replace("/home/error-page");
        return;
    }
      

    let appInfo = this.localStorageService.hasAppInfo(userSession.gcid,userSession.uid)
        ? this.localStorageService.getAppInfo(userSession.gcid, userSession.uid)
        : {
            version: {
              build: "",
              app: "",
              core: ""
            },
      };


      // if we got here then the user is OFFLINE AND is allowed to continue offline as the last user session
      this.setState({
        isLoggedIn: true,
        userSession: userSession,
        userSessionKey: userSessionKey,
        appInfo: appInfo
      });
    
    this.runLotWatcher();
    this.updateSessionExpiration(JwtToken.toExpiredDateTime(this.state.userSession.token));
    this.addConnectionListeners();
    this.setFramesVisibility(true);
    this.goToLandingPage(this.state.userSession.token);
    }

  }


  componentWillUnmount() {
    this.removeConnectionListeners();
  }


  runLotWatcher()
  {
    this.setState({runLotWatcher: true});
  }

  stopLotWatcher()
  {
    this.setState({runLotWatcher: false});
  }





  goToLandingPage(token)
  {
    var landingPage = RoleManager.toLandingPage(token);
    if (landingPage === "")
    {
      this.setState({
        systemErrorMsg:
          "You do not have any rights to any Observation Pages! See your Administrator.",
      });
      this.setFramesVisibility(false);
      this.props.history.replace("/home/error-page");
      return;
    } 
    this.props.history.replace(landingPage);
  }




  onHealthInfoUpdate(updatedHealthInfo)
  {
    var newTriggerKey = IdentityService.makeUuid();
    this.setState({healthInfo: updatedHealthInfo, healthInfoTriggerKey: newTriggerKey});
  }





  setFramesVisibility(showFrames)
  {
    this.setState({showFrames: showFrames});
  }

  onToastRequest(notifyType, msg, toastClosePause, inObservationOverride=false) 
  {
    var displayMsg =  (Array.isArray(msg)) ? msg.join(" ") : msg;
    if ((this.state.inObservationSession) && (!inObservationOverride)) return;
    var newToastClosePause = (toastClosePause) ? toastClosePause: 5000;
    this.setState({toastClosePause: newToastClosePause});
    
    if (notifyType === 'error') {
      toast.error(displayMsg);
    }
    else if (notifyType === 'warning') {
      toast.warning(displayMsg);
    }
    else if (notifyType === 'success') {
      toast.success(displayMsg);
    }
    else {
      toast.info(displayMsg);
    }
  }

  onMsgBoxRequest(title, text, html, icon, confirmButtonText, confirmEvent, cancelButtonText, cancelEvent)
  {
    //console.log(title + ": " + text + " (" + icon + ")");
    this.setState(
      {
        msgBoxSwal: 
        {
          show: true,
          title: title,
          text: text,
          html: html,
          icon: icon,
          confirmButtonText: confirmButtonText ?? "Ok",
          cancelButtonText: cancelButtonText,
          cancelEvent: cancelEvent ?? this.onMsgBoxCloseRequest,
          confirmEvent: confirmEvent ?? this.onMsgBoxCloseRequest
        }
          
      }
    );
  }

  onMsgBoxConfirmRequest()
  {

  }

  onMsgBoxCloseRequest()
  {
    this.setState({msgBoxSwal: {show: false}});
  }


  updateSessionExpiration(newExpirationDateTime)
  {
    this.setState({sessionExpiration: newExpirationDateTime});
  }



  onLotWatcherRunningStatusChange(isRunning)
  {
    this.setState({lotWatcherRunning: isRunning});
  }


  onCurrentLocationIdUpdateRequest(newLocationId)
  {
    var userSession = this.state.userSession;
    userSession.currentLocationId = newLocationId;
    this.setState({userSession: userSession, currentLocationId: newLocationId});
  }

  onCurrentSchemaIdUpdateRequest(newSchemaId)
  {
    var userSession = this.state.userSession;
    userSession.currentSchemaId = newSchemaId;
    this.setState({userSession: userSession, currentSchemaId: newSchemaId});
  }

  onUpdatedLotsEvent(hasUpdatedLots)
  {
    this.setState({hasUpdatedLots: hasUpdatedLots});
  }

  onExpiredToken(token)
  {
    console.log("Token has expired...");
    // clean up
    this.setState({
      isInLogout: true,
      autoRefresh: false,
    });
    this.removeConnectionListeners();
    this.localStorageService.removeLastUserSession();
    this.setState({
      userSession: {},
      sessionExpiration: null,
      observationSessionMode: ObservationSessionMode.NONE,
      globalObsSearchParams: null,
      globalDashSearchParams: null,
      globalObsFilterParams: null,
      globalDashFilterParams: null
    });
    this.stopLotWatcher();
    this.setFramesVisibility(false);


    if (!this.state.isInLogout)
    {
      this.setState({
        systemErrorLevel: SystemErrorLevelType.ERROR,
        systemErrorMsg: "Your session has expired. Please log in again.",

      });
      this.props.history.replace("/home/error-page");
    }
  }

  onHomePageRequest() 
  {
    this.setFramesVisibility(true);
    this.setState({inObservationSession: false})
    this.props.history.replace("/home/home-page");
  }

  onErrorPageRequest(msgs) {
    if (!msgs) {
      msgs = [""];
    }
    this.setFramesVisibility(false);
    this.setState({ systemErrorMsg: Array.isArray(msgs)? msgs.join(" ") : msgs, systemErrorLevel: SystemErrorLevelType.ERROR });
    this.props.history.replace("/home/error-page");
  }


  onLotSelectionChange(lotId) 
  {
    this.setState({ selectedLotId: lotId });
  }


  onSuspendedObservationChange(suspendedTags)
  {
    this.setState({suspendedTags: suspendedTags});
  }


  onUpdateInQueueCount(newCount)
  {
    this.setState({inQueueCount: newCount});
  }

  notAvailableOfflineCheck(overrideMsg)
  {
    if (!this.state.onlineInfo.isConnected)
    {
      this.onMsgBoxRequest("Not Available", (overrideMsg) ? overrideMsg : "This page is not available when you are OFFLINE", "", "warning");
      return true;
    }
    else
    {
      return false;
    }
  }


  async purgeLocalQueue()
  {
    try
    {
      this.stopLotWatcher();
      /* Do we have any observations stored locally? */
      var waitingQueueResponse = await this.localQueuedDbService.fetchAllObservations();
      if (waitingQueueResponse.hasError)
      {
        this.onToastRequest("error", waitingQueueResponse.toMessageString());
        return;
      }
      var queue = waitingQueueResponse.data;
      if (queue.length < 1)
      {
        this.onToastRequest("warning", "It looks like there are no observations to purge from the local queue!");
        return;
      }

      this.onUpdateInQueueCount(queue.length);
      var fileManager = new FileManager();
      var queueCount = queue.length;
      if (queueCount < 1)
      {}
      for (var i = 0; i < queue.length; i++) 
      {
        let observation = queue[i];

        await this.localQueuedDbService.deleteObservation(observation.identifiers.id);
        await fileManager.deleteUserImages(observation);
        await fileManager.deleteUserDocuments(observation);
        queueCount--;
        this.onUpdateInQueueCount(queueCount);
      }
      this.onToastRequest("success", "Successfully removed all observations in the local queue.");
    }
    catch(err)
    {
      this.onToastRequest("error", "There was a problem emptying the local queue " + err.message + ".")
    }
    finally
    {
      this.runLotWatcher();
    }
  }

  async onPurgeOfflineObservationsRequest(inQueueCount)
  {
    /*
    if (inQueueCount < 1)
    {
      this.onMsgBoxRequest("Clear Local Queue", "It looks like you don't have any observations in the local queue waiting to post!", null, "warning");
      return;
    }
    */
    this.onMsgBoxRequest("Clear Local Queue", inQueueCount + " observations currently in local queue. Are you sure you want to purge them? They cannot be recovered.", null, "question", "Purge Queue", this.purgeLocalQueue, "Return");
    return;
  }


  onDataManagementPageRequest()
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.EDIT_DATALISTS, this.state.userSession.token))
    {
        alert(AppSecurityKey.EDIT_DATALISTS.errorMessage);
        return;
    }
    this.props.history.replace("/home/datamanagement-page");
  }

  onUserManagementPageRequest()
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.EDIT_USERS, this.state.userSession.token))
    {
        alert(AppSecurityKey.EDIT_USERS.errorMessage);
        return;
    }
    this.props.history.replace("/home/usermanagement-page");
  }

  onSchemaManagementPageRequest()
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.VIEW_SCHEMAS, this.state.userSession.token))
    {
        alert(AppSecurityKey.VIEW_SCHEMAS.errorMessage);
        return;
    }
    this.props.history.replace("/home/schemamanagement-page");
  }

  onOrgConfigManagementPageRequest()
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.VIEW_ORGCONFIG, this.state.userSession.token))
    {
        alert(AppSecurityKey.VIEW_ORGCONFIG.errorMessage);
        return;
    }
    this.props.history.replace("/home/orgconfigmanagement-page");
  }

  onSubscriberManagementPageRequest()
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.EXPERIMENTAL_ACCESS, this.state.userSession.token))
    {
        alert(AppSecurityKey.EXPERIMENTAL_ACCESS.errorMessage);
        return;
    }
    this.props.history.replace("/home/subscribermanagement-page");
  }

  onDashboardPageRequest()
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.VIEW_DASHBOARD, this.state.userSession.token))
    {
        alert(AppSecurityKey.VIEW_DASHBOARD.errorMessage);
        return;
    }
    this.props.history.replace("/home/dashboard-page");
  }

  onObservationPageRequest(newObservationSessionMode, observationSessionSchemaId, initialValueBag)
  {
    if (newObservationSessionMode === ObservationSessionMode.NONE){
      this.setState({observationSessionMode: newObservationSessionMode});
      return;
    };

    if (!RoleManager.hasRoleRights(newObservationSessionMode.appSecurityKey, this.state.userSession.token))
    {
      alert(newObservationSessionMode.appSecurityKey.errorMessage);
      return;
    }

    var userSession = this.state.userSession;
    userSession.currentSchemaId = observationSessionSchemaId;
    this.setState({
      currentSchemaId: observationSessionSchemaId,
      userSession: userSession
    });

    if (
      (newObservationSessionMode === ObservationSessionMode.RESUME) || 
      (newObservationSessionMode === ObservationSessionMode.COPY) ||
      (newObservationSessionMode === ObservationSessionMode.UPDATE) ||
      (newObservationSessionMode === ObservationSessionMode.DUPLICATE) ||
      (newObservationSessionMode === ObservationSessionMode.READONLY)
      )
    {
      // we need to feed the valuebag so it can be inialized with the suspended values
      this.setState({initialValueBag: initialValueBag});
    }
    else
    {
      // clear the initialValueBag. TBD -  we will use this AGAIN when we copy from existing observation
      this.setState({initialValueBag: {}});
    }
    this.setState({inObservationSession: true, observationSessionMode: newObservationSessionMode, showFrames: false});
    this.props.history.replace("/home/observation-page");
  }



  onViewSharedReportRequest(observation, reportName, userSession)
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.VIEW_SHARED_REPORT, userSession.token))
    {
        alert(AppSecurityKey.VIEW_SHARED_REPORT.errorMessage);
        return;
    }
    // these are values that we would deal with in the page itself
    this.props.history.push({pathname: "/home/sharedreportviewer-page", state: {observation: observation, reportName: reportName, userSession: userSession}});
  }


  onViewReportRequest(observation, reportName)
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.VIEW_REPORT, this.state.userSession.token))
    {
        alert(AppSecurityKey.VIEW_REPORT.errorMessage);
        return;
    }
    // these are values that we would deal with in the page itself
    this.props.history.push({pathname: "/home/reportviewer-page", state: {observation: observation, reportName: reportName}});
  }


  onEntityManagementPageRequest()
  {
    if (this.notAvailableOfflineCheck()) return;
    if (!RoleManager.hasRoleRights(AppSecurityKey.EDIT_ENTITIES, this.state.userSession.token))
    {
        alert(AppSecurityKey.EDIT_ENTITIES.errorMessage);
        return;
    }
    // these are values that we would deal with in the page itself
    this.props.history.replace("/home/entitymanagement-page");
  }

  onChangeHistoryPageRequest()
  {
    this.props.history.replace("/home/changehistory-page");
  }

  onDataApiInstructionsPageRequest()
  {
    this.props.history.replace("/home/dataapiinstructions-page");
  }


  onGeolocationStatusUpdateRequest(isEnabled)
  {
    this.setState({isGeolocationEnabled: isEnabled});
  }


  async onSuccessfulLogin(loginInfo) 
  {
    this.setState({isInLogout: false});
    var userSession = {
      isValid: true,
      gcid: loginInfo.gcid,
      uid: loginInfo.uid,
      token: loginInfo.token,
      roles: loginInfo.roles,
      inboundQueueEnabled: loginInfo.inboundQueueEnabled,
      locations: loginInfo.locations,
      currentLocationId: loginInfo.currentLocationId ?? "",
      currentSchemaId: loginInfo.currentSchemaId ?? "",
      schemas: loginInfo.schemas,
      app: loginInfo.app, 

    };
    var appInfo = {
      version: {
        build: loginInfo.buildVer,
        app: loginInfo.appVer,
        core: loginInfo.coreVer
      },
    };
    var newUserSessionKey = UserSessionKey.fromUserSession(userSession).toQueryString();
    console.group("In HomeLayout - onSuccessfulLogin after creating a userSession");
    console.info(userSession);
    console.groupEnd();
    this.localStorageService.saveLastUserSession(userSession);
    this.updateSessionExpiration(JwtToken.toExpiredDateTime(userSession.token));
    var inQueueCount = await this.localQueuedDbService.fetchObservationCount();

    this.setState({
      isLoggedIn: true,
      userSession: userSession,
      currentLocationId: userSession.currentLocationId,
      currentSchemaId: userSession.currentSchemaId,
      appInfo: appInfo,
      userSessionKey: newUserSessionKey, // needed to trigger header panel setting proper changed location
      autoRefresh: true,
      inQueueCount: inQueueCount
    });
    this.runLotWatcher();
    this.localStorageService.saveAppInfo(
      loginInfo.gcid,
      loginInfo.uid,
      appInfo
    );

    var suspendedTagsResponse = await this.localSuspendedDbService.fetchAllSuspendedTags();
    if (suspendedTagsResponse.hasError)
    {
      this.setFramesVisibility(false);
      this.setState({
        systemErrorLevel: SystemErrorLevelType.ERROR,
        systemErrorMsg: "Problem checking for suspended tags"
      });
      this.props.history.replace("/home/error-page");
      return;
    }
    var allSuspendedTags = suspendedTagsResponse.data;
    this.setState({suspendedTags: allSuspendedTags});


    this.addConnectionListeners();
    this.setFramesVisibility(true);

    // based on role, determine where they should land
    this.goToLandingPage(this.state.userSession.token);

   // this.props.history.replace("/home/home-page");
  }

  onLogoutRequest() 
  {
    if (this.notAvailableOfflineCheck("You cannot log out if you are not online!")) return;
    console.log("Logging out...");
    // clean up
    this.setState({
      isInLogout: true,
      autoRefresh: false,
    });
    this.removeConnectionListeners();
    this.localStorageService.removeLastUserSession();
    this.setState({
      userSession: {},
      sessionExpiration: null,
      observationSessionMode: ObservationSessionMode.NONE,
      globalObsSearchParams: null,
      globalDashSearchParams: null,
      globalObsFilterParams: null,
      globalDashFilterParams: null
    });
    this.stopLotWatcher();
    this.setFramesVisibility(false);
    this.props.history.replace("/home/auth-page");
  }

  addConnectionListeners() {
    window.addEventListener("online", this.handleConnectionChange);
    window.addEventListener("offline", this.handleConnectionChange);
  }

  removeConnectionListeners() {
    window.removeEventListener("online", this.handleConnectionChange);
    window.removeEventListener("offline", this.handleConnectionChange);
  }

  handleConnectionChange = () => {
    console.group("Connection Info");
    console.info(navigator.connection);
    console.groupEnd();

    let onlineInfo = this.state.onlineInfo;
    const condition = navigator.onLine ? "online" : "offline";
    onlineInfo.isOnline = condition === "online";
    onlineInfo.isConnected =
      onlineInfo.isAirplaneMode !== true && onlineInfo.isOnline;
    console.group("OnlineInfo Change:");
    console.info(onlineInfo);
    console.groupEnd();
    var onlineStatusChangeKey = IdentityService.makeUuid();
    if (onlineInfo.isConnected)
    {
      this.runLotWatcher();
    }
    else
    {
      this.stopLotWatcher();
    }
    this.setState({ onlineInfo: onlineInfo, onlineStatusChangeKey: onlineStatusChangeKey });
    return onlineInfo;
  };


  onToggleAirplaneModeRequest()
  {
    var onlineInfo = this.state.onlineInfo;
    var isAirplaneMode = !onlineInfo.isAirplaneMode;
    onlineInfo.isAirplaneMode = isAirplaneMode;
    this.setState({onlineInfo: onlineInfo});
    this.handleConnectionChange();
  }

  onAboutOpen = () => 
  {
    // pass in current navigator info
    var connectionInfo = navigator.connection;
    var navigatorInfo = {"connection": {downlink: connectionInfo?.downlink, effectiveType: connectionInfo?.effectiveType, rtt: connectionInfo?.rtt}, "online": this.state.onlineInfo};
    this.setState({navigatorInfo: navigatorInfo,  isAboutOpen: true });
  }

  onAboutClose() {
    this.setState({ isAboutOpen: false });
  }



  onToggleAutoRefresh(e)
  {
    var newAutoRefresh = (e.target.checked);
    this.setState({autoRefresh: newAutoRefresh});
    if (e.target.checked)
    {
      this.onTriggerAutoRefresh();
    }

  }

  onTriggerAutoRefresh()
  {
    var newKey = IdentityService.makeUuid();
    this.setState({autoRefreshTriggerKey: newKey});
  }




  onUserGuideRequest()
  {
    var userGuideFilePath = new ConfigService().getUserGuideFilePath(this.state.userSession.gcid);
    window.open(userGuideFilePath,"_blank");
  }

  render() 
  {

    return (
      <ChakraProvider>

        {this.state.isLoggedIn &&
          <MsgBox {...this.state.msgBoxSwal} 
            onMsgBoxCloseRequest={this.onMsgBoxCloseRequest}
          />
        }

        <ToastContainer
          position="top-right"
          autoClose={this.state.toastClosePause}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> 


   
        {this.state.isLoggedIn &&
        <ModalAbout
          isOpen={this.state.isAboutOpen}
          onClose={this.onAboutClose}
          deviceInfo={this.deviceInfo}
          appInfo={this.state.appInfo}
          onlineInfo={this.state.onlineInfo}
          userSession={this.state.userSession}
          navigatorInfo={this.state.navigatorInfo}
        />
        }
 

        {this.state.isLoggedIn &&
        <Navbar
          onlineInfo = {this.state.onlineInfo}
          onlineStatusChangeKey = {this.state.onLineStatusChangeKey}
          isAirplanMode={this.state.isAirplaneMode}
          onToggleAirplaneModeRequest={this.onToggleAirplaneModeRequest}
          isVisible={this.state.showFrames}
          userSession={this.state.userSession}
          onHomePageRequest={this.goToLandingPage}
          onAboutOpen={this.onAboutOpen}
          onLogoutRequest={this.onLogoutRequest}
          onUserGuideRequest={this.onUserGuideRequest}
          onDataManagementPageRequest={this.onDataManagementPageRequest}
          onUserManagementPageRequest={this.onUserManagementPageRequest}
          onSchemaManagementPageRequest = {this.onSchemaManagementPageRequest}
          onOrgConfigManagementPageRequest = {this.onOrgConfigManagementPageRequest}
          onSubscriberManagementPageRequest = {this.onSubscriberManagementPageRequest}
          onNotificationManagementPageRequest = {this.onNotificationManagementPageRequest}
          onDashboardPageRequest = {this.onDashboardPageRequest}
          onMockReportPageRequest={this.onMockReportPageRequest}
          onEntityManagementPageRequest={this.onEntityManagementPageRequest}
          onErrorPageRequest={this.onErrorPageRequest}
          onChangeHistoryPageRequest={this.onChangeHistoryPageRequest}
          onDataApiInstructionsPageRequest={this.onDataApiInstructionsPageRequest}
          onPurgeOfflineObservationsRequest={this.onPurgeOfflineObservationsRequest}
          currentLotId={this.state.selectedLotId}
          currentLocationId = {this.state.currentLocationId}
          onCurrentLocationIdUpdateRequest = {this.onCurrentLocationIdUpdateRequest}
          sessionExpiration={this.state.sessionExpiration}
          alertSecondsLeft={180}
          expireSecondsLeft={60}
          onExpiredToken={this.onExpiredToken}
          inQueueCount={this.state.inQueueCount}


          lotWatcherRunning={this.state.lotWatcherRunning}
          onLotWatcherRunningStatusChange={this.onLotWatcherRunningStatusChange}

          onToggleAirplaneMode={this.onToggleAirplaneMode}
          onRefreshUserSessionKey={this.onRefreshUserSessionKey}
          inObservationSession={this.state.inObservationSession}
          isGeolocationEnabled={this.state.isGeolocationEnabled}
          autoRefresh={this.state.autoRefresh}
          healthInfo={this.state.healthInfo}
          healthInfoTriggerKey={this.state.healthInfoTriggerKey}

        />
      }


        {this.state.isLoggedIn &&
        <Sidebar 
          isVisible={false}
          userSession={this.state.userSession}
          onErrorPageRequest={this.onErrorPageRequest}
          onHomePageRequest={this.onHomePageRequest}
          onAboutOpen={this.onAboutOpen} 
          onLogoutRequest={this.onLogoutRequest}
          onUserGuideRequest={this.onUserGuideRequest}
          onDataManagementPageRequest={this.onDataManagementPageRequest}
          onUserManagementPageRequest={this.onUserManagementPageRequest}
        />
        }


        <LotWatcher
          userSession={this.state.userSession}
          onErrorPageRequest={this.onErrorPageRequest}
          onlineInfo = {this.state.onlineInfo}
          runLotWatcher={this.state.runLotWatcher}
          updateSessionExpiration={this.updateSessionExpiration}
          onExpiredToken={this.onExpiredToken}
          onToastRequest={this.onToastRequest}
          onUpdatedLotsEvent={this.onUpdatedLotsEvent}
          onLotWatcherRunningStatusChange={this.onLotWatcherRunningStatusChange}
          autoRefresh={this.state.autoRefresh}
          onTriggerAutoRefresh={this.onTriggerAutoRefresh}
          healthInfo={this.state.healthInfo}
          onHealthInfoUpdate={this.onHealthInfoUpdate}
          onUpdateInQueueCount={this.onUpdateInQueueCount}
        />
        

        <Box className={(this.state.showFrames) ? "adminview": "adminview-hidden"}>

          <Switch>
            <Route
              path="/home/home-page"
              render={(props) => (
                <ObsHomePage
                  {...props}
                  deviceInfo={this.deviceInfo}
                  appInfo={this.state.appInfo}
                  onlineInfo={this.state.onlineInfo}
                  userSession={this.state.userSession}
                  userSessionKey={this.state.userSessionKey} // used to trigger changes
                  onToastRequest={this.onToastRequest}
                  onMsgBoxRequest={this.onMsgBoxRequest}
                  currentSchemaId={this.state.currentSchemaId}
                  currentLocationId={this.state.currentLocationId}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onHomePageRequest={this.onHomePageRequest}
                  onLogoutRequest={this.onLogoutRequest}
                  hasUpdatedLots={this.state.hasUpdatedLots}
                  onCurrentSchemaIdUpdateRequest={this.onCurrentSchemaIdUpdateRequest}
                  onObservationPageRequest={this.onObservationPageRequest}
                  suspendedTags={this.state.suspendedTags}
                  onSuspendedObservationChange={this.onSuspendedObservationChange}
                  autoRefresh={this.state.autoRefresh}
                  onToggleAutoRefresh={this.onToggleAutoRefresh}
                  autoRefreshTriggerKey={this.state.autoRefreshTriggerKey}
                  onViewReportRequest={this.onViewReportRequest}
                  globalSearchParams={this.state.globalObsSearchParams}
                  onGlobalSearchParamsChange={this.onGlobalSearchParamsChange}
                  globalFilterParams={this.state.globalObsFilterParams}
                  onGlobalFilterParamsChange={this.onGlobalFilterParamsChange}
                />
              )}
            />


            <Route
              path="/home/dashboard-page"
              render={(props) => (
                <DashboardPage {...props}
                  userSession={this.state.userSession}
                  onErrorPageRequest={this.onErrorPageRequest}
                  userSessionKey={this.state.userSessionKey} // used to trigger changes
                  onToastRequest={this.onToastRequest}
                  onMsgBoxRequest={this.onMsgBoxRequest}
                  currentSchemaId={this.state.currentSchemaId}
                  currentLocationId={this.state.currentLocationId}
                  onHomePageRequest={this.onHomePageRequest}
                  onLogoutRequest={this.onLogoutRequest}
                  hasUpdatedLots={this.state.hasUpdatedLots}
                  onCurrentSchemaIdUpdateRequest={this.onCurrentSchemaIdUpdateRequest}
                  autoRefresh={this.state.autoRefresh}
                  onToggleAutoRefresh={this.onToggleAutoRefresh}
                  autoRefreshTriggerKey={this.state.autoRefreshTriggerKey}
                  onViewReportRequest={this.onViewReportRequest}
                  healthInfo={this.state.healthInfo}
                  healthInfoTriggerKey={this.state.healthInfoTriggerKey}
                  globalSearchParams={this.state.globalDashSearchParams}
                  onGlobalSearchParamsChange={this.onGlobalSearchParamsChange}
                  globalFilterParams={this.globalDashFilterParams}
                  onGlobalFilterParamsChange={this.onGlobalFilterParamsChange}

                />
              )}
            />


            <Route
              path="/home/auth-page"
              render={(props) => (
                <AuthPage
                  {...props}
                  deviceInfo={this.deviceInfo}
                  onSuccessfulLogin={this.onSuccessfulLogin}
                />
              )}
            />
            <Route
              path="/home/error-page"
              render={(props) => (
                <ErrorPage
                  {...props}
                  onLogoutRequest={this.onLogoutRequest}
                  systemErrorLevel={this.state.systemErrorLevel}
                  systemErrorMsg={this.state.systemErrorMsg}
                />
              )}
            />

            <Route
              path="/home/changehistory-page"
              render={(props) => (
                <ChangeHistoryPage
                  {...props}
                  onLogoutRequest={this.onLogoutRequest}
                  systemErrorLevel={this.state.systemErrorLevel}
                  systemErrorMsg={this.state.systemErrorMsg}
                />
              )}
            />


            <Route
              path="/home/dataapiinstructions-page"
              render={(props) => (
                <DataApiInstructionsPage
                  {...props}
                  userSession={this.state.userSession}
                  onErrorPageRequest={this.onErrorPageRequest}
                  userSessionKey={this.state.userSessionKey} // used to trigger changes
                  onToastRequest={this.onToastRequest}
                  onMsgBoxRequest={this.onMsgBoxRequest}
                  currentSchemaId={this.state.currentSchemaId}
                  currentLocationId={this.state.currentLocationId}
                  onLogoutRequest={this.onLogoutRequest}
                  onCurrentSchemaIdUpdateRequest={this.onCurrentSchemaIdUpdateRequest}
                  globalSearchParams={this.state.globalDashSearchParams}
                  onGlobalSearchParamsChange={this.onGlobalSearchParamsChange}
                />
              )}
            />
            
            <Route
              path="/home/datamanagement-page"
              render={(props) => (
                <DataManagementPage {...props}
                  userSession={this.state.userSession}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  onMsgBoxRequest={this.onMsgBoxRequest}
                  onExpiredToken={this.onExpiredToken}
                />
              )}
            />

            <Route
              path="/home/schemamanagement-page"
              render={(props) => (
                <SchemaManagementPage {...props}
                  userSession={this.state.userSession}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  onExpiredToken={this.onExpiredToken}
                />
              )}
            />

            <Route
              path="/home/orgconfigmanagement-page"
              render={(props) => (
                <OrgConfigManagementPage {...props}
                  userSession={this.state.userSession}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  onExpiredToken={this.onExpiredToken}
                />
              )}
            />

            <Route
              path="/home/subscribermanagement-page"
              render={(props) => (
                <SubscriberManagementPage {...props}
                  userSession={this.state.userSession}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  onExpiredToken={this.onExpiredToken}
                />
              )}
            />

            <Route
              path="/home/usermanagement-page"
              render={(props) => (
                <UserManagementPage {...props}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  userSession={this.state.userSession}
                  onExpiredToken={this.onExpiredToken}
                />          
              )}
            />



            <Route
              path="/home/reportviewer-page"
              render={(props) => (
                <ReportNavigatorPage {...props}
                  onHomePageRequest={this.onHomePageRequest}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  userSession={this.state.userSession}
                  onExpiredToken={this.onExpiredToken}
                />          
              )}
            />

            <Route
              path="/home/sharedreportviewer-page"
              render={(props) => (
                <SharedReportNavigatorPage {...props}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  userSession={this.state.userSession}
                  onExpiredToken={this.onExpiredToken}
                />          
              )}
            />

            <Route
              path="/home/entitymanagement-page"
              render={(props) => (
                <EntityManagementPage {...props}
                  userSession={this.state.userSession}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onHomePageRequest={this.onHomePageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  onMsgBoxRequest={this.onMsgBoxRequest}
                  onExpiredToken={this.onExpiredToken}    
                />
              )}
            />


            <Route
              path="/home/observation-page"
              render={(props) => (
                <ObservationPage {...props}
                  userSession={this.state.userSession}
                  onlineInfo={this.state.onlineInfo}
                  onErrorPageRequest={this.onErrorPageRequest}
                  onHomePageRequest={this.onHomePageRequest}
                  onLoginExpire={this.onLogoutRequest}
                  onToastRequest={this.onToastRequest}
                  onMsgBoxRequest={this.onMsgBoxRequest}
                  onExpiredToken={this.onExpiredToken}
                  observationSessionMode={this.state.observationSessionMode}
                  inObservationSession={this.state.inObservationSession}
                  currentSchemaId={this.state.currentSchemaId}
                  initialValueBag={this.state.initialValueBag}
                  onGeolocationStatusUpdateRequest={this.onGeolocationStatusUpdateRequest}
                  onSuspendedObservationChange={this.onSuspendedObservationChange}
                  sessionExpiration={this.state.sessionExpiration}
                  alertSecondsLeft={180}
                  expireSecondsLeft={60}
                  runLotWatcher={this.runLotWatcher}
                  stopLotWatcher={this.stopLotWatcher}
                  onUpdateInQueueCount={this.onUpdateInQueueCount}
                  
                />
              )}
            />



            <Redirect from="/" to="/home/home-page" />
            <Redirect from="/home" to="/home/home-page" />
          </Switch>

        </Box>
      </ChakraProvider>
    );
  }
}
